
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fiis/[tickerSymbol]/financials",
      function () {
        return require("private-next-pages/fiis/[tickerSymbol]/financials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fiis/[tickerSymbol]/financials"])
      });
    }
  